<template>
  <b-row>
    <b-card class="mt-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter
             :mode="tab.mode" 
             @handleSubmit="searchFilterSubmit"
            />
          </b-col>

        </b-tab>
      </b-tabs>

    </b-card>

    <b-col
      v-for="tab in activeTab"
      :id="tab"
      :key="tab"
      cols="12"
    >
      <commonTable
        ref="tableCommon"
        :mode="tab"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
// import commonTable from '../../table/vue-good-table/commonTableAppreve.vue'
import commonTable from "./components/commonTable.vue";
import SearchFilter from "./components/SearchFilter.vue";
import * as viewStore from "@/store/api/approve/approve.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    viewStore,
  },
  methods: {
    setActiveTabName(name) {
      this.activeTab = []
      this.activeTab.push(name)
    },
    searchFilterSubmit(params) {
      //console.log('searchFilterSubmit', params, this.$refs)
      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
  },
  data() {
    return {
      tabs: [
        { title: 'หนังสือรอลงนาม', mode: 'List' },
        // { title: 'ประวัติดำเนินการ', mode: 'History' },
      ],
      activeTab: ['List'],
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
